<script setup lang="ts">
import { ref, onMounted } from "vue";
import axios from 'axios'

import AxiosUserService from "../utils/axiosUserService";
const axiosUserService = new AxiosUserService();

const userMsg = ref()
function getUser(){

  axiosUserService.getCurrentUser(localStorage.token)
  .then(function (res) {      
      userMsg.value = res.data
      
  }).catch(function (res) {
    localStorage.setItem("token", "")
    localStorage.setItem("userId", "")
    localStorage.setItem("isPaid", "")
    localStorage.setItem("userRole", "")
    console.log('Current User error',res)    
  })
}
onMounted(()=>{
    getUser()
})
</script>

<template>
  <nav class="sidebar bg-black-1 flex column j-between scroll">
    <a href="/" class="p-20">
      <img class="logo-sm" src="/logo_2024.png" alt="">
    </a>

    <div class="flex column">
      <!-- <router-link class="navItem" to="/cms/index">Home</router-link> -->
      <div class="label black-4 p-10">User</div>
      <router-link class="navItem" to="/cms/userlist"><span class="icon-user white-1"></span> Members</router-link>
      <router-link class="navItem" to="/cms/mentorlist"><span class="icon-judge white-1"></span> Mentors</router-link>
      <router-link class="navItem" to="/cms/application"><span class="icon-message white-1"></span> Application</router-link>
      <router-link class="navItem" to="/cms/orglist"><span class="icon-organization white-1"></span> Organizations</router-link>
      <router-link class="navItem" to="/cms/userActivity"><span class="icon-people white-1"></span> User Activities</router-link>
      
      <div class="label black-4 p-10">Product</div>
      <router-link class="navItem" to="/cms/categoryList"><span class="icon-menu white-1"></span> Categories</router-link>
      <router-link class="navItem" to="/cms/videoCategory"><span class="icon-watch white-1"></span> Videos</router-link>
      <router-link class="navItem" to="/cms/articleList"><span class="icon-read white-1"></span> Articles</router-link>
      <router-link class="navItem" to="/cms/articleAudioList"><span class="icon-micro white-1"></span> Audio</router-link>
      <router-link class="navItem" to="/cms/debatelist"><span class="icon-speak white-1"></span> Speak</router-link>
      <router-link class="navItem" to="/cms/materialList"><span class="icon-library white-1"></span> Materials</router-link>
      
      <div class="label black-4 p-10">Others</div>
      <router-link class="navItem" to="/cms/blogPostList"><span class="icon-files white-1"></span> Blog Post List</router-link>
      <router-link class="navItem" to="/cms/eventList"><span class="icon-event white-1"></span> Event List</router-link>
      <router-link class="navItem" to="/cms/adlist"><span class="icon-boardcast white-1"></span> Ads</router-link>
      <router-link class="navItem" to="/cms/magazineList"><span class="icon-book white-1"></span> Magazine</router-link>

    </div>
    <div class="mt-40">

      <router-link class="navItem" to="/"><span class="icon-dashboard white-1"></span>Dashboard</router-link>
      <router-link class="navItem" to="/"><span class="icon-home white-1"></span>Home</router-link>
    </div>

    <!-- <hr>
    <div>
      <img :src="userMsg.avatar !== null? `/api/v1/user/avatar/storage/`+userMsg.avatar.file_id : '/avatar-default.png'" class="avatar-sm">
      <strong>{{userMsg.nick_name}}</strong>
    </div> -->
  </nav>
</template>

<style >
@import '../assets/css_lib/themimir.css';
.sidebar {
  width: 200px;
  height: 100vh;
  
}
.navItem{
  padding: 5px 20px;
  display: flex;
  align-items: center;
  gap: 5px
}
.navItem, .navItem > *{
  color: white;
}
.navItem:hover{
  background-color: #b780ff;
}
</style>